var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPawColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48021 7.18505C9.2375 7.18505 10.6668 5.57376 10.6668 3.59269C10.6668 1.61176 9.23744 0 7.48021 0C5.72343 0 4.29395 1.61171 4.29395 3.59269C4.29395 5.57376 5.72343 7.18505 7.48021 7.18505Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9314 10.6798C16.8661 10.605 16.8034 10.5345 16.7699 10.4738C16.0574 9.19261 14.1043 7.68218 10.94 7.64461L10.8183 7.64404C7.70259 7.64404 5.764 9.07452 4.98839 10.4138C4.9616 10.4596 4.90267 10.5191 4.84024 10.5819C4.76637 10.6556 4.69329 10.7309 4.6308 10.8129C3.97558 11.6691 3.64152 12.6331 3.6908 13.5272C3.74246 14.4764 4.21553 15.2388 5.02059 15.6737C5.34585 15.8492 5.69684 15.9376 6.06508 15.9376C6.8244 15.9376 7.5196 15.5784 8.32522 15.1623C8.83742 14.8971 9.36649 14.6235 9.95416 14.4187C10.02 14.4004 10.2899 14.3726 10.7313 14.3726C11.2561 14.3726 11.6331 14.4118 11.7136 14.4352C12.2873 14.6479 12.7911 14.927 13.2784 15.1963C14.0254 15.6099 14.7307 16.0002 15.496 16.0002C15.8245 16.0002 16.1428 15.9274 16.4431 15.784C18.1 14.9933 18.4157 12.8237 17.1471 10.948C17.0835 10.8539 17.0076 10.766 16.9314 10.6798Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2556 7.18505C16.0121 7.18505 17.4417 5.57376 17.4417 3.59269C17.4417 1.61176 16.0121 0 14.2556 0C12.4982 0 11.0688 1.61171 11.0688 3.59269C11.0688 5.57376 12.4982 7.18505 14.2556 7.18505Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4887 5.34033C18.0803 5.34033 16.978 6.5673 16.978 8.13368C16.978 9.69935 18.0809 10.9265 19.4887 10.9265C20.8963 10.9265 21.9999 9.69935 21.9999 8.13368C21.9999 6.56734 20.8969 5.34033 19.4887 5.34033Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0216 8.13368C5.0216 6.56734 3.91868 5.34033 2.51091 5.34033C1.10308 5.34033 0 6.56734 0 8.13368C0 9.69935 1.10308 10.9265 2.51091 10.9265C3.91874 10.9265 5.0216 9.69935 5.0216 8.13368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawColor);
export default __webpack_public_path__ + "static/media/paw_color.8cb9ca9ca311ffb3c9df5a03aabbab51.svg";
export { ForwardRef as ReactComponent };